"use strict"
import Vue from "vue"
import axios from "axios"
import { cacheAdapterEnhancer } from "axios-extensions"
import authHeader from "../services/auth-header"
import { router } from "../main"
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  // headers: { 'Cache-Control': 'no-cache' },
  //adapter: throttleAdapterEnhancer(cacheAdapterEnhancer(axios.defaults.adapter))
  adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false, cacheFlag: "useCache" })
}

const _axios = axios.create(config)

// INTERCEPT REQUEST
_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

_axios.interceptors.request.use(function(config) {
  const url = `${String(process.env.VUE_APP_URL).replace('/api/v1', '')}`;
  if (config.url.includes(url)) {
    const token = sessionStorage.getItem("token")
    if (token) {
      config.headers["Authorization"] = authHeader().Authorization
    }
    config.headers["Content-Type"] = "application/json"
    return config
  }
  return config;
})

// INTERCEPT RESPONSE
_axios.interceptors.response.use(
  function(response) {
    if (response && response.request && response.request.status === 401) {
      sessionStorage.clear()
      return router.push("/login")
    }
    return response
  },
  function(error) {
    if (axios.isAxiosError(error)) {
      if (error && error.response && error.response.status === 401) {
        sessionStorage.clear()
        return router.push("/login")
      }
    }
    return Promise.reject(error)
  }
)

Plugin.install = function(Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
